<div class="pt-3 pr-5 pb-5 pl-5">
    <div class="mt-3 p-3 col-12 w-12" >        
        <app-eea-run-project-qc #qcComponent  *ngIf="runQc" [runs] ="runs" [selectedProject]="selectedProject" [isPWC]="false"></app-eea-run-project-qc>
    </div>
</div>
<app-loading class="flex align-items-center justify-content-center" *ngIf="loading"></app-loading>